export interface QuarterlyReports {
    quarterCourseRegistrationSignal: any | null;
    totalCourseRegistrationSignal: any | null;
    quarterCourseCertificateSignal: any | null;
    totalCourseCertificateSignal: any | null;
    topOrganizationsSignal: any | null;
    topDomainsSignal: any | null;
    accountMetricsSignal: any | null;
    websiteAnalyticsSignal: any | null;
    loadingQuarterCourseRegistrationSignal: boolean;
    loadingTotalCourseRegistrationSignal: boolean;
    loadingQuarterCourseCertificateSignal: boolean;
    loadingTotalCourseCertificateSignal: boolean;
    loadingTopOrganizationsSignal: boolean;
    loadingTopDomainsSignal: boolean;
    loadingAccountMetricsSignal: boolean;
    loadingWebsiteAnalyticsSignal: boolean;
  }

  export const quarterlyReportsInitialState: QuarterlyReports = {
    quarterCourseRegistrationSignal: null,
    totalCourseRegistrationSignal: null,
    quarterCourseCertificateSignal: null,
    totalCourseCertificateSignal: null,
    topOrganizationsSignal: null,
    topDomainsSignal: null,
    accountMetricsSignal: null,
    websiteAnalyticsSignal: null,
    loadingQuarterCourseRegistrationSignal: false,
    loadingTotalCourseRegistrationSignal: false,
    loadingQuarterCourseCertificateSignal: false,
    loadingTotalCourseCertificateSignal: false,
    loadingTopOrganizationsSignal: false,
    loadingTopDomainsSignal: false,
    loadingAccountMetricsSignal: false,
    loadingWebsiteAnalyticsSignal: false,
  };
